import { createApp } from 'vue'
import router from './router'
import i18n from './i18n';
import store from './store';
import App from './App.vue'
import genericTooltip from '@/directives/genericTooltip';
import vClickOutside from 'click-outside-vue3'
import { installFrontendErrorLogging } from '@/utils/frontendErrorLogger';

const app = createApp(App)

app.use(i18n);
app.use(router);
app.use(store);
app.use(vClickOutside);

app.directive('tooltip', genericTooltip);
installFrontendErrorLogging(app);

app.mount('#app');
